import * as actionTypes from '../actions/reservations/actionTypes';

const initialState = {
    bookings: [],
    bundles: [],
    loading: false,
    noMoreBookings: false,
    reservationsGetError: null,
    pastBookings: [],
    pastBundles: [],
    pastLoading: true,
    noMorePastBookings: false,
    pastReservationsGetError: null,
    reservationDetails: null
};

const reducer = (state = initialState, {type, ...action}) => {
    switch(type) {
        case actionTypes.GET_RESERVATIONS:
            return {
                ...state,
                loading: true,
                reservationsGetError: null
            };
        case actionTypes.GET_RESERVATIONS_SUCCEEDED: {
            const {bookings, bundles, loadMore} = action;
            return {
                ...state,
                bookings: !loadMore ? bookings : [
                    ...state.bookings,
                    ...bookings
                ],
                bundles,
                loading: false,
                noMoreBookings: bookings.length === 0
            };
        }
        case actionTypes.GET_RESERVATIONS_FAILED: {
            const {err} = action;
            return {
                ...state,
                loading: false,
                reservationsGetError: err
            };
        }
        case actionTypes.GET_PAST_RESERVATIONS:
            return {
                ...state,
                pastLoading: true,
                pastReservationsGetError: null
            };
        case actionTypes.GET_PAST_RESERVATIONS_SUCCEEDED:
            const {bookings: pastBookings, bundles: pastBundles, loadMore} = action;
            return {
                ...state,
                pastBookings: !loadMore ? pastBookings : [
                    ...state.pastBookings,
                    ...pastBookings
                ],
                pastBundles,
                pastLoading: false,
                noMorePastBookings: pastBookings.length === 0
            };
        case actionTypes.GET_PAST_RESERVATIONS_FAILED:
            const {err} = action;
            return {
                ...state,
                pastLoading: false,
                pastReservationsGetError: err
            };
        case actionTypes.GET_RESERVATION_DETAILS:
            return {
                ...state,
                reservationDetails: null
            };
        case actionTypes.GET_RESERVATION_DETAILS_SUCCEEDED:
            const {details: reservationDetails} = action;
            return {
                ...state,
                reservationDetails
            };
        case actionTypes.CANCEL_BOOKING_SUCCEEDED: {
            const bookings = state.bookings.filter(({id}) => id !== action.id);
            const bundles = state.bundles.filter(({id}) => id !== action.id);
            return {
                ...state,
                bookings,
                bundles
            };
        }
        default:
            return state;
    }
};

export default reducer